module.exports = __webpack_public_path__ + "static/media/text-section.11bb088a.png";